import computeClassName from "../../../../../../../utils/computeClassName";

const constants = Object.freeze({
  CLASSNAME_BASE: 'truncate',
  CLASSNAME_DROPDOWN_IS_DISABLED: {
    true: {
      TEXT_IS_PLACEHOLDER: {
        true: 'text-cc-gray-60 font-semibold',
        false: 'text-cc-gray-60 font-semibold'
      }
    },
    false: {
      TEXT_IS_PLACEHOLDER: {
        true: 'text-cc-gray-100 font-semibold',
        false: 'text-cc-gray-100 font-semibold'
      }
    }
  },
});


function getComputedClassName(propsClassName, dropdownIsDisabled, textIsPlaceholder) {
  return computeClassName(propsClassName, `${constants.CLASSNAME_BASE} ${constants.CLASSNAME_DROPDOWN_IS_DISABLED[dropdownIsDisabled].TEXT_IS_PLACEHOLDER[textIsPlaceholder]}`);
}


export default function CCFormDropdownOpenCloseControlText(
  {
    dropdownPlaceholderText,
    dropdownMultipleSelectionText,
    dropdownReplaceCountInMultipleSelectionText,
    dropdownCountKeyword,
    dropdownMultipleSelectionTextShownIfCountAbove,
    dropdownSelectedOptionSeparator,
    dropdownIsDisabled,
    dropdownSelectedOptions,
    dropdownOptionKeyLabel,
    className = ''
  }
) {
  const computedDropdownSelectedOptionsCount = dropdownSelectedOptions?.length || 0;
  const textIsPlaceholder = computedDropdownSelectedOptionsCount === 0;
  const computedClassName = getComputedClassName(className, dropdownIsDisabled, textIsPlaceholder);

  if (textIsPlaceholder) {
    return <span className={computedClassName}>{dropdownPlaceholderText}</span>
  }
  else {
    let computedText;
    if (computedDropdownSelectedOptionsCount === 1) {
      computedText = dropdownSelectedOptions[0][dropdownOptionKeyLabel];
    }
    else {
      if (computedDropdownSelectedOptionsCount > dropdownMultipleSelectionTextShownIfCountAbove) {
        if (dropdownReplaceCountInMultipleSelectionText) {
          computedText = dropdownMultipleSelectionText.replace(dropdownCountKeyword, computedDropdownSelectedOptionsCount);
        }
      }
      else {
        const computedSelectedOptionLabels = dropdownSelectedOptions.map((selectedOption)=>selectedOption[dropdownOptionKeyLabel]);
        computedText = computedSelectedOptionLabels.join(dropdownSelectedOptionSeparator);
      }
    }
    return <span className={computedClassName}>{computedText}</span>
  }
}
